export function beforeEnterCheckPermission(permissions) {
  if (typeof permissions != 'function') return;
  const { isCanRead = false } = permissions();
  return {
    has: isCanRead,
    redirectTo: '404',
  };
}
